import React, { Component } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { Col, Container, Row, Form } from 'react-bootstrap';
import PhoneClinicGrid from '../../Components/PhoneClinicGrid';
import RowActions from '../../Components/PhoneClinicGrid/RowActions';
import Select from '../../Components/PCSelect';
// import CreatableSelect from 'react-select/creatable';
import axios from "axios";
// import Alert from '@mui/material/Alert';
import RefreshIcon from '@mui/icons-material/Refresh';
import Swal from "sweetalert2";
import { debounceFunc } from './../../helper'
import FormCard from './shared/FormCard';

class CommonInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {

            addInventory: false,
            InventoryList: [],

            ITEM_ID: "",
            ITEM_NAME: "",
            ITEM_CATEGORY: "",
            ITEM_MODEL: "",
            ITEM_DESC: "",
            ITEM_BARCODE: "",
            ITEM_DEVICE: "",


            DeviceList: [],
            CategoryList: []

        }
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getCommonInventory(searchGridData, totalRecordsPerPage.value, paginationValue);
    // }

    async getCommonInventory(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetCommonInventory.php`, formData);
        let serviceData = getAllInventory.data
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            pagination.totalItems = parseInt(serviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ InventoryList })
        this.props.toggleLoader(false)
    }

    handleEdit(indx) {
        let { InventoryList } = this.state;
        let FilteredData = InventoryList[indx];
        this.getAllDevice()
        this.getAllCategory()
        this.setState({
            addInventory: true,
            ITEM_ID: FilteredData.INV_ID,
            ITEM_NAME: FilteredData.INV_ITEM_NAME,
            ITEM_CATEGORY: {
                'label': FilteredData.INV_CATEGORY_NAME,
                'value': FilteredData.INV_CATEGORY
            },
            ITEM_DEVICE: {
                'label': FilteredData.DEVICE_NAME,
                'value': FilteredData.DEVICE_ID
            },
            ITEM_MODEL: FilteredData.INV_MODEL,
            ITEM_DESC: FilteredData.INV_DESC,
            ITEM_BARCODE: FilteredData.INV_BARCODE
        })
    }

    async getAllDevice() {
        const getDevices = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getAllDevice.php`);
        let deviceData = getDevices.data
        let DeviceList = []
        if (deviceData.success === 1) {
            let InventoryList = deviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                DeviceList.push({
                    'label': element.Brand_Name,
                    'value': element.Brand_ID,
                    'id': element.Brand_ID
                })
            }
        }
        this.setState({ DeviceList })
    }

    async getAllCategory() {
        const getDevices = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getAllCategory.php`);
        let deviceData = getDevices.data
        let CategoryList = []
        if (deviceData.success === 1) {
            let InventoryList = deviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                CategoryList.push({
                    'label': element.ItemCategory,
                    'value': element.ItemCategoryID_PK
                })
            }
        }
        this.setState({ CategoryList })
    }

    hanldeAddInventory() {
        this.getAllDevice()
        this.getAllCategory()
        this.setState({ addInventory: true })
    }

    handleChange(name, evt) {
        switch (name) {
            case "ITEM_CATEGORY":
            case "ITEM_DEVICE":
                this.setState({ [name]: evt })
                break;

            default:
                this.setState({ [name]: evt.target.value })
                break;
        }
    }

    ValidateInvoice() {
        if (this.state.ITEM_NAME === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                "Enter Item Name",
                'error'
            )
            return false
        }
        if (this.state.ITEM_DEVICE === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                "Select Brand",
                'error'
            )
            return false
        }
        if (this.state.ITEM_CATEGORY === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                "Select Category",
                'error'
            )
            return false
        }
        if (this.state.ITEM_BARCODE === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                "Enter Item Barcode",
                'error'
            )
            return false
        }

        return true
    }

    async handleSave() {
        this.props.toggleLoader(true)
        if (!this.ValidateInvoice()) return
        let FormData = {
            ITEM_ID: this.state.ITEM_ID,
            ITEM_NAME: this.state.ITEM_NAME,
            ITEM_CATEGORY: this.state.ITEM_CATEGORY?.value || "",
            ITEM_MODEL: this.state.ITEM_MODEL,
            ITEM_DESC: this.state.ITEM_DESC,
            ITEM_BARCODE: this.state.ITEM_BARCODE,
            ITEM_DEVICE: this.state.ITEM_DEVICE?.value || "",
        }

        let ReturnDataResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddCommonInventory.php`, FormData);

        if (ReturnDataResult.data.status === 200) {
            Swal.fire(
                'Success',
                ReturnDataResult.data.message,
                'success'
            )
        } else {
            Swal.fire(
                'Error',
                ReturnDataResult.data.message,
                'error'
            )
        }
        this.handleCancel()
    }

    handleCancel() {
        this.getCommonInventory()

        this.setState({
            addInventory: false,
            ITEM_ID: "",
            ITEM_NAME: "",
            ITEM_CATEGORY: "",
            ITEM_DEVICE: "",
            ITEM_MODEL: "",
            ITEM_DESC: "",
            ITEM_BRAND: {},
            ITEM_BARCODE: "",
            ITEM_BUY_RATE: "",
            ITEM_SELL_RATE: "",
            ITEM_QUANTITY: "",
            searchGridData: ""
        })
    }

    render() {
        const { addInventory } = this.state
        return (
            <Container>
                {addInventory === false ?

                    <PhoneClinicGrid
                        title="INVENTORY"
                        buttonLabel="Add Inventory"
                        onClickButton={this.hanldeAddInventory.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        getData={this.getCommonInventory.bind(this)}
                        tableHeadData={[
                            { label: "ITEM", isHidden: false },
                            { label: "BRAND", isHidden: false },
                            { label: "CATEGORY", isHidden: false },
                            { label: "BARCODE", isHidden: false },
                        ]}
                    >
                        {this.state.InventoryList.map((service, idx) => {
                            return (
                                <TableRow
                                    key={idx}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <TableCell>{service.INV_ITEM_NAME}</TableCell>
                                    <TableCell>{service.DEVICE_NAME}</TableCell>
                                    <TableCell>{service.INV_CATEGORY_NAME}</TableCell>
                                    <TableCell>{service.INV_BARCODE}</TableCell>
                                    <TableCell align='center'>
                                        <RowActions actions={[
                                            { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                        ]} />
                                    </TableCell>
                                </TableRow>

                            )
                        }

                        )}
                    </PhoneClinicGrid>
                    :
                    <div>
                        <FormCard title={this.state.ITEM_ID ? 'Edit Inventory Item' : 'Add Inventory Item'} mode={this.state.ITEM_ID ? 'edit' : 'new'}
                            onCancel={this.handleCancel.bind(this)}
                            onSave={this.handleSave.bind(this)} saveLabel="Save">
                        <Row>
                            <legend style={{ borderBottom: '1px solid #a32f2f' }} >Inventory</legend>
                        </Row>
                        <Row style={{ margin: "5px" }} >
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Item</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                       
                                        name="ITEM_NAME"
                                        value={this.state.ITEM_NAME}
                                        onChange={this.handleChange.bind(this, 'ITEM_NAME')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Select menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        style={{ height: '32px' }}
                                        name="ITEM_DEVICE"
                                        value={this.state.ITEM_DEVICE}
                                        options={this.state.DeviceList}
                                        onChange={this.handleChange.bind(this, 'ITEM_DEVICE')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Category</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Select menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        style={{ height: '32px' }}
                                        name="ITEM_CATEGORY"
                                        value={this.state.ITEM_CATEGORY}
                                        options={this.state.CategoryList}
                                        onChange={this.handleChange.bind(this, 'ITEM_CATEGORY')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                       
                                        type={"textarea"}
                                        name="ITEM_DESC"
                                        value={this.state.ITEM_DESC}
                                        onChange={this.handleChange.bind(this, 'ITEM_DESC')}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Model</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                        style={{ height: '32px' }}
                                        name="ITEM_MODEL"
                                        value={this.state.ITEM_MODEL}
                                        onChange={this.handleChange.bind(this, 'ITEM_MODEL')}
                                    />
                                </Form.Group>
                            </Col> */}
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Barcode</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                       
                                        name="ITEM_BARCODE"
                                        value={this.state.ITEM_BARCODE}
                                        onChange={this.handleChange.bind(this, 'ITEM_BARCODE')}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </div>
                }
            </Container>
        );
    }
}

export default CommonInventory;